import bem from 'utils/bem';

export const block = bem('upload-text-step');

export function splitArticleParagraphs(article?: string) {
  return !article ? [] : article.split('\n');
}
